import * as yup from 'yup';
export const commonCalendarEventMaintenanceValidation: { [x: string]: any; } = {
  customerCode: yup.string().required("Missing."),
  docType: yup.string().required("Missing."),
  adjType: yup.string().trim().required("Missing."),
  exchangeRateRefDateAttr: yup.string().required("Missing."),
  adjustment: yup.number().required("Missing."),
  activeInd: yup.string().required("Missing."),
};
export const createExchangeRateRefDateMappingValidation: { [x: string]: any; } = {
  ...commonCalendarEventMaintenanceValidation,
};
export const createExchangeRateRefDateMappingValidationSchema = yup.object().shape(createExchangeRateRefDateMappingValidation); 
